var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.15625 7.00016C0.15625 3.31826 3.14102 0.333496 6.82292 0.333496C10.5048 0.333496 13.4896 3.31826 13.4896 7.00016C13.4896 10.682 10.5048 13.6668 6.82292 13.6668C3.14102 13.6668 0.15625 10.682 0.15625 7.00016ZM9.53992 4.28829C9.84105 4.50018 9.91332 4.91605 9.70145 5.21716L6.53478 9.71716C6.41832 9.88263 6.23305 9.9863 6.03112 9.9989C5.82912 10.0115 5.63238 9.9317 5.49632 9.78196L3.82962 7.94863C3.58195 7.67616 3.60203 7.25456 3.87447 7.0069C4.1469 6.75923 4.56854 6.7793 4.81621 7.0517L5.92318 8.26943L8.61105 4.44984C8.82292 4.14872 9.23878 4.0764 9.53992 4.28829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerify);
export default __webpack_public_path__ + "static/media/icon-verify.119cbeed17027ce46336116f0639e240.svg";
export { ForwardRef as ReactComponent };